import type { FaqFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

export const googleProjectManagementFaqs = (productPrice: number): Array<FaqFragment> => {
  return [
    {
      id: '1',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What is the refund policy?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'If you subscribed, you get a 7-day free trial during which you can cancel at no penalty. After that, we don’t give refunds, but you can cancel your subscription at any time. '
          )}<a href="https://learner.coursera.help/hc/en-us/articles/208280266-Refund-policies">${_t(
          'See our full refund policy.'
        )}</a></text>
        </co-content>
      `,
      },
    },
    {
      id: '2',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Can I just enroll in a single course?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Yes! To get started, click the course card that interests you and enroll. You can enroll and complete the course to earn a shareable certificate, or you can audit it to view the course materials for free. When you subscribe to a course that is part of a Certificate, you’re automatically subscribed to the full Certificate. Visit your learner dashboard to track your progress.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '3',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Is this course really 100% online? Do I need to attend any classes in person?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'This course is completely online, so there’s no need to show up to a classroom in person. You can access your lectures, readings and assignments anytime and anywhere via the web or your mobile device.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '4',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What is project management?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Project management is the application of knowledge, skills, tools, and techniques to project activities to meet the project requirements. Project managers ensure projects within an organization are managed and completed with maximum value and benefits realized.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '5',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Why start a career in project management?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Project managers are in high demand. In fact, a '
          )}<a href="https://www.pmi.org/-/media/pmi/documents/public/pdf/learning/job-growth-report.pdf">${_t(
          'study'
        )}</a>${_t(
          ' by the Project Management Institute found that, by the year 2027, employers will need 87.7 million people to fill project management-related roles. As the workplace continues to grow and evolve, project managers serve as a pivotal piece of an organization’s ability to adapt and remain agile.'
        )}</text>
          <text>${_t(
            'Project managers are natural problem-solvers. In addition to setting the plan and guiding teammates through the project, they are tasked with managing changes and risks. Each day is dynamic and different for a project manager because they are at the center of the project, building relationships, prioritizing tasks, and delivering results! Using various tools and templates, as well as a unique skill set, the project manager brings order to chaos.'
          )}</text>
          <text><a href="https://www.pmi.org/learning/careers/job-growth">¹PMI (2017). Project Management Job Growth and Talent Gap 2017–2027</a>.</text>
        </co-content>
      `,
      },
    },
    {
      id: '6',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('How much does this certificate cost?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Now INR #{productPrice}!', { productPrice })}</text>
          <text>${_t(
            'In India, Coursera charges INR #{productPrice}/month after the initial 7 day free trial period. The certificate can be completed in less than 6 months of part time study. Google does not generate any revenue from Google Career Certificates and has made need-based financial assistance available.',
            { productPrice }
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '7',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Is this program offered in other languages?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('This certificate is currently available globally in English.')}</text>
        </co-content>
      `,
      },
    },
    {
      id: '8',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What background knowledge is necessary?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'None! Whether you’re completely new to the job field or have had some exposure, a Google Career Certificate is the right program for you.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '9',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Do I need to take the courses in a specific order?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'We highly recommend taking the courses of each certificate program in the order presented, as the content builds on information from earlier courses.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '10',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Which tools and platforms are taught in the curriculum?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Spreadsheets (e.g., Google Sheets, Microsoft Excel, etc.), word processing applications (e.g., Google Docs, Microsoft Word, etc.), and presentation applications (e.g., Google Slides, Microsoft PowerPoint, etc.) will be used. Additionally, learners will have the option to use Asana and to learn about other common work management tools.'
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '11',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Which jobs does this program prepare for?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'One of the most exciting parts about joining the field of project management is the large number of job opportunities available. In fact, the Project Management Institute '
          )}<a href="https://www.pmi.org/-/media/pmi/documents/public/pdf/learning/job-growth-report.pdf">${_t(
          'estimates'
        )}</a>${_t(
          ' that employers will need to fill nearly 2.2 million new project-oriented roles '
        )}<strong>each year through 2027.</strong></text>
          <text>The Google Project Management Certificate helps you develop essential project management skill sets and business acumen. By learning and practicing the project management approaches included in this program, you’ll prepare yourself for introductory-level project manager roles across a variety of industries. Some common titles include Program Manager, Junior Project Manager, Project Coordinator, Scrum Master, and more. Project management is a skill that lends itself to many different types of roles in numerous industries with many opportunities for career growth.</text>
        </co-content>
      `,
      },
    },
    {
      id: '12',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What kind of companies hire project management professionals?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            `By learning the project management skills included within this program, you’ll prepare yourself for project manager roles across a multitude of industries and sectors. Project managers are found in every kind of organization--as employees, managers, contractors, and independent consultants. With experience, they may become program managers (responsible for multiple related projects) or portfolio managers (responsible for selection, prioritization, and alignment of projects and programs with an organization's strategy).`
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '13',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Will completing this certificate help prepare me for Project Management Institute certifications?'
          )}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Google is an approved member of the '
          )}<a href="https://www.pmi.org/"> Project Management Institute’s</a>${_t(
          ' Authorized Training Partner Program, which ensures practitioners have access to consistent and high-quality training experiences. Those who complete the Google Project Management Certificate will qualify for over 100 hours of project management education that apply directly to requirements for globally-recognized PMI credentials, like the '
        )}<a href="https://www.pmi.org/certifications/certified-associate-capm">Certified Associate in Project Management (CAPM)® certification</a>${_t(
          ', at a discounted price.'
        )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '14',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What will I be able to do upon completing the professional certificate?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Google Career Certificates are designed to prepare you for an entry-level role in job fields like IT support, data analytics, project management, or UX design - whether that’s doing in-person or remote work, at a small company or a large enterprise organization. '
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '15',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('What resources will be available to help with the job search process?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            `In addition to expert-led training and hands-on projects designed to prepare you for a job, you'll get access to interview tips, mock interviews and resume building workshops, career coaching sessions and more.`
          )}</text>
        </co-content>
      `,
      },
    },
    {
      id: '16',
      question: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t('Why did Google create this program?')}</text>
        </co-content>
      `,
      },
      answer: {
        dtdId: '1',
        htmlWithMetadata: {
          html: '',
          metadata: {
            hasAssetBlock: false,
            hasCodeBlock: false,
            hasMath: false,
            isPlainText: true,
          },
        },
        cmlValue: `
        <co-content>
          <text>${_t(
            'Google had long faced an issue that many other companies also contend with: they had open IT Support roles, and not enough qualified candidates to fill them. So they built and tested a training program to provide pathways to jobs in technical support at Google, for people with no college degree or experience. In 2018, Google launched the #{product}',
            { product: '' }
          )}<strong>IT Support Career Certificate</strong>${_t(
          ', so that this training could be available to everyone. Since then, thousands of people have completed the program, making it the top professional certificate program on Coursera. 82% of U.S. program graduates report a positive career outcome within 6 months of completion, such as getting a new job, promotion or raise.'
        )}</text>
          <text>${_t(
            'When Google saw the positive impact this program was having on people all over the world, they wanted to expand into additional fast-growing, high-paying career fields – Project Management, Data Analytics and UX Design. These certificates, built and taught by Google, are designed to prepare people from all backgrounds for jobs where there is great demand for qualified candidates. Like the IT Support Certificate, no relevant experience is required.'
          )}</text>
        </co-content>
      `,
      },
    },
  ];
};

export default googleProjectManagementFaqs;
